import { CURRENCIES } from '@savgroup-front-common/constants/shared';

import { intl } from '../helpers/intl';

export const getCurrencySymbol = (currencyCode = CURRENCIES.EUR) => {
  let code = currencyCode.toUpperCase().padStart(3, '0').slice(0, 3);

  try {
    intl?.formatNumber(1, {
      style: 'currency',
      currency: code,
    });
  } catch {
    code = 'EUR';
  }

  const formatted = intl?.formatNumber(1, {
    style: 'currency',
    currency: code,
    currencyDisplay: 'symbol',
  });

  return (
    formatted
      ?.replaceAll(' ', '')
      .replace('1.00', '')
      .replace('1,00', '')
      ?.trim() || code
  );
};
